import { render, staticRenderFns } from "./DetailWo.vue?vue&type=template&id=4963c9c4"
import script from "./DetailWo.vue?vue&type=script&lang=js"
export * from "./DetailWo.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports